import React, {useState} from "react";

const TemplateInputPosition = (props) => {
    const [position,setPosition] = useState("");
    const handleChange = (e) => setPosition(e.target.value);
    return (
        <div className='input-details'>
            <input onChange={handleChange}
                placeholder='Type your position'
                style={props.positionStyleObj} />
        </div>
    )};

export default TemplateInputPosition;
